import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import cn from 'bem-cn';

import { Button } from '../UI';

import { NotFoundContentProps } from './NotFoundContent.types';
import './NotFoundContent.scss';

const b = cn('not-found-content');

export const NotFoundContent: FC<NotFoundContentProps> = ({ className }) => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div className={b.mix(className)}>
            <h1 className={b('404')}>404</h1>
            <p className={b('text')}>Страница не найдена</p>
            <Button className={b('button')} onClick={handleGoHome} variant="primary" size="large">
                Вернуться на главную
            </Button>
        </div>
    );
};
